import { RESET_CAMPAIGNS } from './actionTypes';

export default () => ({ type: RESET_CAMPAIGNS });
